import React from 'react'
import InfiniteScroll from 'react-infinite-scroller'

import { Head, IEditableTableHead } from './head'
import { IData } from 'components/layout/table'
import RapidEditableTableRow from './rapidEditableTableRow'
import Loader from 'components/ui/loader'

export interface IRapidEditableTableConfig {
  dataSetName: string
  dataName: string
  head: IEditableTableHead[]
}

interface IEditableData extends IData {
  [k: string]: {
    value: string | number
    unit?: string
    editable?: boolean
  }
}

export interface IEditableItem {
  id: string
  custom?: boolean
  data?: IEditableData
}

interface IProps {
  config: IRapidEditableTableConfig
  hasMoreItems?: boolean
  isLoading?: boolean
  data: IEditableItem[]
  onLoadMore: (page: number) => void
  onChange?: (item: IEditableItem) => void
}

interface IState {
  items: IEditableItem[]
}

class RapidEditableTable extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props)

    this.state = {
      items: props.data,
    }
  }

  componentWillReceiveProps = (nextProps: IProps) => {
    const { data } = this.props
    if (nextProps.data !== data) {
      this.setState({ items: nextProps.data })
    }
  }

  hasItems = () => this.state.items.length > 0

  handleChange = (item: IEditableItem) => {
    const { onChange } = this.props

    if (onChange) {
      onChange(item)
    }
  }

  getUnit = (key: string) => {
    const { head } = this.props.config
    const headItem = head.find((headItem: IEditableTableHead) => headItem.key === key)
    return headItem && headItem.unit ? headItem.unit : null
  }

  loadItems = (page: number) => {
    const { onLoadMore } = this.props
    onLoadMore(page)
  }

  public render() {
    const { items } = this.state
    const { hasMoreItems, isLoading } = this.props
    const { dataSetName, head } = this.props.config

    const tableData = (
      <div>
        {this.hasItems() ? (
          <InfiniteScroll
            pageStart={1}
            initialLoad={true}
            loadMore={this.loadItems}
            hasMore={hasMoreItems}
            loader={
              <div key={0}>
                <Loader />
              </div>
            }
          >
            {items.map((elem: IEditableItem, index) => {
              return (
                <RapidEditableTableRow
                  onChange={this.handleChange}
                  item={elem}
                  key={index}
                  head={head}
                />
              )
            })}
          </InfiniteScroll>
        ) : isLoading || hasMoreItems ? (
          <Loader />
        ) : (
          <div className={`flex py-10 border-gray-200 border-b-1`}>
            <p className={`w-full text-black text-13 font-400 tracking-0.1`}>
              {`Es ist keine ${dataSetName} vorhanden.`}
            </p>
          </div>
        )}
      </div>
    )

    return (
      <>
        <div className="w-full mb-10 px-48">
          <Head head={head} />
          {tableData}
        </div>
      </>
    )
  }
}

export default RapidEditableTable
